var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComposition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 4.16675H16.6667C14.375 4.16675 12.5 6.04175 12.5 8.33341V33.3334C12.5 35.6251 14.375 37.5001 16.6667 37.5001H41.6667C43.9584 37.5001 45.8334 35.6251 45.8334 33.3334V8.33341C45.8334 6.04175 43.9584 4.16675 41.6667 4.16675ZM41.6667 33.3334H16.6667V8.33341H41.6667V33.3334ZM26.0417 31.2501C28.9167 31.2501 31.25 28.9167 31.25 26.0417V14.5834H37.5V10.4167H29.1667V21.8959C28.2917 21.2292 27.2292 20.8334 26.0417 20.8334C23.1667 20.8334 20.8334 23.1667 20.8334 26.0417C20.8334 28.9167 23.1667 31.2501 26.0417 31.2501ZM8.33335 12.5001H4.16669V41.6667C4.16669 43.9584 6.04169 45.8334 8.33335 45.8334H37.5V41.6667H8.33335V12.5001Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 45.8334,
    y1: 15.6368,
    x2: 4.12338,
    y2: 17.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5134B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F34D21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposition);
export default __webpack_public_path__ + "static/media/composition.f1a131747f6901ecc6718bb79104618e.svg";
export { ForwardRef as ReactComponent };